import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Ekip kutusu (spec 2026-10-24 §5.2): 12'den büyük yaprak ekibin zemini. Kartlar bu düğümün ÜSTÜNDE ayrı düğümlerdir
// (zIndex -1); kutu yalnız başlık ve zemin çizer, tıklanmaz.
const Box = styled.div`
  position: relative;
  box-sizing: border-box;
  width: ${({ $w }) => $w}px;
  height: ${({ $h }) => $h}px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.orgChart.teamBox};
  border: 1px solid ${({ theme }) => theme.colors.orgChart.teamBoxBorder};
  pointer-events: none;
`;

const Head = styled.span`
  position: absolute;
  left: 14px;
  top: 7px;
  font: 700 12px 'Nunito Sans', sans-serif;
  color: ${({ theme }) => theme.colors.text.muted};
  white-space: nowrap;
`;

export default function TeamBoxNode({ data }) {
  const { t } = useTranslation();
  const title = data.parentName
    ? t('orgChart.teamBoxTitle', { name: data.parentName, count: data.count })
    : t('orgChart.teamBoxTitleNoName', { count: data.count });
  return (
    <Box data-testid={`team-box-${data.parentId || 'root'}`} $w={data.width} $h={data.height}>
      <Head>{title}</Head>
    </Box>
  );
}
